import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import sanityClient from "../../sanityClient";
import WOW from "wowjs";
import Slider from "react-slick";

export default function HomeProject() {
    const [projects, setProjects] = useState([]);

    // Memoized slider settings to avoid re-creating on every render
    const sliderSettings = useMemo(() => ({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1500,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
    }), []);

    useEffect(() => {
        const wowInstance = new WOW.WOW({ live: false });
        wowInstance.init();

        sanityClient
            .fetch(`*[_type == "project" && showOnHome == true && !defined(deletedAt)] | order(createdAt desc){
                title,
                city,
                category->{title},
                bannerImages[]{asset->{url}},
                slug
            }`)
            .then((data) => {
                setProjects(data);
                setTimeout(() => wowInstance.sync(), 100);
            })
            .catch(console.error);
    }, []);

    return (
        <section className="home-project">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="vector-heading">
                            <img src="./assets/home/shape-vector.png" alt="vector" />
                            <h4 className="heading">our projects</h4>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        {projects.slice(0, 3).map((project, index) => (
                            <div 
                                className="project-box wow animate__animated animate__slideInUp"
                                data-wow-duration="1s"
                                key={project.slug.current || index}
                            >
                                <Link to={`/project/${project.slug.current}`}>
                                    <h4 className="heading">{project.title}</h4>
                                    <p>{project.category?.title} • {project.city}</p>
                                    <div className="projectbox-slider">
                                        <img 
                                            src="/assets/home/grey-curve.svg"
                                            className="pro-curve"
                                            alt="shape"
                                            loading="lazy"
                                        />
                                        <Slider {...sliderSettings}>
                                            {project.bannerImages.map((image, imgIndex) => (
                                                <img
                                                    key={imgIndex}
                                                    src={image.asset.url}
                                                    className="img-responsive"
                                                    alt={`project ${index}`}
                                                    loading="lazy"
                                                />
                                            ))}
                                        </Slider>
                                    </div>
                                </Link>
                            </div>
                        ))}
                        <div className="text-center">
                            <Link to="/project" className="default-btn">
                                view all projects<span></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
